<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item label="用户ID">
                <a-input v-model="queryParam.userId" placeholder="请输入用户ID" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="标题">
                <a-input v-model="queryParam.title" placeholder="请输入标题" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="消息类型">
                <a-select v-model="queryParam.type" placeholder="请选择" allow-clear>
                  <a-select-option :value="0">平台消息</a-select-option>
                  <a-select-option :value="1">订单消息</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="已读状态">
                <a-select v-model="queryParam.isRead" placeholder="请选择" allow-clear>
                  <a-select-option :value="false">未读</a-select-option>
                  <a-select-option :value="true">已读</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:message:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1200 }"
      >
        <span slot="type" slot-scope="text">
          {{ text === 0 ? '平台消息' : text === 1 ? '订单消息' : text }}
        </span>
        <span slot="isRead" slot-scope="text">
          <a-tag :color="text ? 'green' : 'orange'">{{ text ? '已读' : '未读' }}</a-tag>
        </span>
        <span slot="content" slot-scope="text">
          <a-tooltip v-if="text" :title="text">
            <span>{{ text.length > 40 ? text.slice(0, 40) + '...' : text }}</span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="showDetail(record)" v-hasPermi="['user:message:query']">
            <a-icon type="eye" />详情
          </a>
          <a-divider type="vertical" v-hasPermi="['user:message:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:message:remove']" style="color: #ff4d4f;">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>

      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />

      <a-drawer title="消息详情" :width="520" :visible="detailVisible" @close="detailVisible = false">
        <a-descriptions bordered :column="1" size="small" v-if="detail">
          <a-descriptions-item label="ID">{{ detail.id }}</a-descriptions-item>
          <a-descriptions-item label="用户ID">{{ detail.userId }}</a-descriptions-item>
          <a-descriptions-item label="类型">{{ detail.type === 0 ? '平台消息' : '订单消息' }}</a-descriptions-item>
          <a-descriptions-item label="已读">{{ detail.isRead ? '是' : '否' }}</a-descriptions-item>
          <a-descriptions-item label="标题">{{ detail.title }}</a-descriptions-item>
          <a-descriptions-item label="内容">{{ detail.content }}</a-descriptions-item>
          <a-descriptions-item label="公告ID">{{ detail.noticeId || '-' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ parseTime(detail.createTime) }}</a-descriptions-item>
        </a-descriptions>
      </a-drawer>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageUserMessage, getUserMessage, delUserMessage } from '@/api/user/message'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'UserMessage',
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      multiple: true,
      loading: false,
      total: 0,
      detailVisible: false,
      detail: null,
      queryParam: {
        userId: undefined,
        title: undefined,
        type: undefined,
        isRead: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '用户ID', dataIndex: 'userId', align: 'center', width: 120 },
        { title: '标题', dataIndex: 'title', ellipsis: true, align: 'center', width: 180 },
        { title: '内容', dataIndex: 'content', scopedSlots: { customRender: 'content' }, align: 'center', width: 220 },
        { title: '类型', dataIndex: 'type', scopedSlots: { customRender: 'type' }, align: 'center', width: 100 },
        { title: '已读', dataIndex: 'isRead', scopedSlots: { customRender: 'isRead' }, align: 'center', width: 80 },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center', width: 160 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 140, fixed: 'right' }
      ]
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.loading = true
      pageUserMessage(this.queryParam).then(res => {
        this.list = res.data.records || []
        this.total = res.data.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        title: undefined,
        type: undefined,
        isRead: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.multiple = !selectedRowKeys.length
    },
    showDetail (record) {
      getUserMessage({ id: record.id }).then(res => {
        this.detail = res.data
        this.detailVisible = true
      })
    },
    handleDelete (row) {
      const ids = row.id ? [{ id: row.id }] : this.selectedRows.map(item => ({ id: item.id }))
      const that = this
      this.$confirm({
        title: '确认删除所选消息?',
        onOk () {
          return delUserMessage(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功')
          })
        }
      })
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    }
  }
}
</script>
